/*eslint-disable */
import toast from '@/services/toast';
import {
  bus
} from '@/main';
export default {
  name: 'create-plan',
  components: {
  },
  props: [],
  data () {
    return {
      subscriptionPlanInfoResults:[],
      selfUserId:'',
      name:'',
      description:'',
      submitted:false,
      product_id:'',
      payment_failure_threshold:'',
      regular_payment_info:{
        frequency:{
          interval_unit:'',
          interval_count:''
        },
        tenure_type:'REGULAR',
        sequence:'1',
        total_cycles:'',
        pricing_scheme:{
          fixed_price:{
            value:'',
            currency_code:'USD'
          }
        }
      },
      free_trail_info:{
        frequency:{
          interval_unit:'',
          interval_count:''
        },
        tenure_type:'TRIAL',
        sequence:'1',
        total_cycles:'',
        pricing_scheme:{
          fixed_price:{
            value:'',
            currency_code:'USD'
          }
        }
      },
      free_trail_section:false
    }
  },
  computed: {
  },
  mounted () {
    bus.$on('createSubscriptionProductStateBus', (data) => {
      this.createSubscriptionProductState = data;
    });
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.$store.dispatch('getSubscriptionProductListFunc').then((res) => {
      this.subscriptionPlanInfoResults = res.data
    })
  },
  methods: {
    closeCreateSubscriptioProductPopup(){
      bus.$emit('createSubscriptionProductStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    createSubscriptionProductBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            product_id:this.product_id,
            name:this.name,
            description:this.description,
            status:'ACTIVE',
            payment_preferences:{
              auto_bill_outstanding:true,
              setup_fee:{
                value:0,
                currency_code:'USD'
              },
              setup_fee_failure_action:'CONTINUE',
              payment_failure_threshold:this.payment_failure_threshold
            },
            taxes:{
              percentage:0,
              inclusive:false
            },
            billing_cycles:[]
          }
          if(this.free_trail_section){
            this.regular_payment_info.sequence = '2'
            data.billing_cycles.push(this.free_trail_info)
            data.billing_cycles.push(this.regular_payment_info)
          }else{
            data.billing_cycles.push(this.regular_payment_info)
          }
          this.$store.dispatch('createSubscriptionPlanInfoFunc', data).then((res) => {  
            toast.success('Subscription plan is created successfully');
            this.submitted =  false
            this.$store.dispatch('getSubscriptionPlanListFunc');
            this.closeCreateSubscriptioProductPopup();
          }).catch((err) => {
            toast.error('Request is failed');
            this.submitted =  false
          })
        return;
        }
      })
    }
  }
}